import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<Statistic>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Analytics/Statistics`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: Statistic;
}

export type Statistic = {
	[key: string]: Resource;
};

export type Resource = {
	resourceName: string;
	count: number;
	color: string | null;
};
